import { PartialRecord } from 'types/typeutils';

export const filterObjectByEntries = <T extends Record<string, any>>(
	obj: T,
	filterEntry: (entry: [keyof T, T[keyof T]]) => boolean
): Partial<T> => {
	const entries = Object.entries(obj) as [keyof T, T[keyof T]][];
	const filtered = entries.filter(filterEntry);
	return Object.fromEntries(filtered) as Partial<T>;
};

export const filterObjectByValues = <T extends Record<string, any>>(
	obj: T,
	filterValue: (value: T[keyof T]) => boolean
): Partial<T> => {
	const entries = Object.entries(obj) as [keyof T, T[keyof T]][];
	const filtered = entries.filter(([, value]) => filterValue(value));
	return Object.fromEntries(filtered) as Partial<T>;
};

export const filterObjectByKeyMask = <T extends Record<string, any>>(
	obj: T,
	keyMask: PartialRecord<keyof T, any>
) => {
	const entries = Object.entries(obj) as [keyof T, T[keyof T]][];
	const filtered = entries.filter(([key]) => keyMask[key]);
	return Object.fromEntries(filtered) as Partial<T>;
};
